module.exports = __webpack_public_path__ + "static/img/img05@2x.299372d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img05@2x.png
// module id = zmwp
// module chunks = 174